/**
 * Generic error helpers shared across features.
 */

/** The error's own message when it has one, else the caller's fallback copy. */
export function errorMessage(err: unknown, fallback: string): string {
  return err instanceof Error && err.message ? err.message : fallback;
}
